import { createSlice } from "@reduxjs/toolkit";
import { fetchAds } from "./AdminAction";

const initialState = {
    pendingAds: [], // ads to be quoted by admin
    notifications:[],      // complete notification of accepted and rejected ads

    rejectedAds:[], // ads rejected by user
    acceptedAds:[], // ads accepted by user
    // helpers
    error: null,
    loading: false,
    success: false,
}

export const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        adminLogout: (state) => {
            state.pendingAds=[];
            state.notifications=[];

            // helper
            state.error=null;
            state.loading=false;
            state.success=false;
        },
    },
    extraReducers: (builder) => {

        //fetchAds Pending Fulfilled Rejected
        builder.addCase(fetchAds.pending, (state, action) => {
            state.loading = true
            state.error = false
        })
        builder.addCase(fetchAds.fulfilled, (state, { payload }) => {

            console.log('payload in admin slice : ',payload)
            console.log(payload.ads.pending)
            state.loading = false
            state.success = true // fetching successful
            state.pendingAds = payload.ads.pending  

            state.rejectedAds = payload.ads.negotiation 
            state.acceptedAds = payload.ads.accepted    

            
            state.notifications = [...payload.ads.negotiation,...payload.ads.accepted]  
        })
        builder.addCase(fetchAds.rejected, (state, { payload }) => {
            state.loading = false
            state.error = payload
        })

    }
})

export default adminSlice.reducer
export const { adminLogout } = adminSlice.actions
